import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { ITypedReduxAction } from '../../types/redux';

export enum EPreviewOffersActionType {
  Add = 'previewOffers/add',
  Request = 'previewOffers/request',
  Success = 'previewOffers/success',
  Failure = 'previewOffers/failure',
}

/** payload - объявления пина, которые уже загрузил листинг: кладём без запроса */
export type TPreviewOffersAdd = ITypedReduxAction<EPreviewOffersActionType.Add, IDailyRentOfferForMobileSite[]>;
export type TPreviewOffersRequest = ITypedReduxAction<EPreviewOffersActionType.Request>;
/** payload - офферы из ответа бека */
export type TPreviewOffersSuccess = ITypedReduxAction<EPreviewOffersActionType.Success, IDailyRentOfferForMobileSite[]>;
export type TPreviewOffersFailure = ITypedReduxAction<EPreviewOffersActionType.Failure>;

export type TPreviewOffersActions =
  | TPreviewOffersAdd
  | TPreviewOffersRequest
  | TPreviewOffersSuccess
  | TPreviewOffersFailure;
